<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div v-if="showMessage" class="toast align-items-center text-bg-success fade show position-fixed top-0 end-0"
    role="alert" aria-live="assertive" aria-atomic="true" data-bs-config='{"delay":5000, "autohide":true}'
    style="z-index:9999;">
    <div class="d-flex">
      <div class="toast-body">Student Added Successfuly.</div>
      <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="p-3">
        <div class="d-flex align-items-center">
          <h5 class="mb-0 text-primary"> <i class="fas fa-user-tie text-primary"></i> Add Student</h5>
        </div>
        <hr />
        <div class="row g-3">
          <div class="col-md-6">
            <label for="inputFirstName" class="form-label">Roll No<sup><span class="text-danger font-12">*</span></sup>
              :</label>
            <input type="text" class="form-control form-control-sm form-control form-control-sm-sm" id="inputFirstName"
              v-model="student.rollNo" />
          </div>
          <div class="col-md-6">
            <label for="inputLastName" class="form-label">Admission Number :</label>
            <input type="text" class="form-control form-control-sm form-control form-control-sm-sm" id="inputLastName"
              v-model="student.admissionNumber" />
          </div>
        </div>

        <div class="row g-3">
          <div class="col-md-6">
            <label for="inputFirstName" class="form-label">First Name<sup><span
                  class="text-danger font-12">*</span></sup> :</label>
            <input type="text" class="form-control form-control-sm form-control form-control-sm-sm" id="inputFirstName"
              v-model="student.firstName" />
          </div>
          <div class="col-md-6">
            <label for="inputLastName" class="form-label">Last Name :</label>
            <input type="text" class="form-control form-control-sm form-control form-control-sm-sm" id="inputLastName"
              v-model="student.lastName" />
          </div>
          <div class="col-md-6">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{clsList.find(c => c._id === student.clsID)?.name || ""}}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu">
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="student.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label" for="inputGroupSelect01">Section<sup><span
                  class="text-danger font-12">*</span></sup> :</label>
            <select class="form-select form-select-sm cursor-pointer" role="button" id="inputGroupSelect01"
              v-model="student.sectionID">
              <option selected=""></option>
              <option v-for="(item, index) in secList" :key="index" :value="item._id">
                {{ item.Name }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="date" class="form-label">Date of Birth :</label>
            <input class="date form-control form-control-sm form-control form-control-sm-sm" type="date" id="date"
              value="" v-model="student.dob" />
          </div>
          <div class="col-md-6">
            <label for="genderOptions" class="form-label">Gender<sup><span class="text-danger font-12">*</span></sup>
              :</label>
            <div class="row col-md-12 mt-1 ml-15" id="genderOptions">
              <div class="form-check radio-inline col-md-3 ms-md-3 ms-0">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Male"
                  v-model="student.gender" id="maleCheck" />
                <label class="form-check-label" for="maleCheck">M</label>
              </div>
              <div class="form-check radio-inline col-md-3">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Female"
                  v-model="student.gender" id="femaleCheck" />
                <label class="form-check-label" for="femaleCheck">F</label>
              </div>
              <div class="form-check radio-inline col-md-3">
                <input class="form-check-input border-dark" type="radio" name="gender" value="Other"
                  v-model="student.gender" id="otherCheck" />
                <label class="form-check-label" for="otherCheck">Other</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label for="inputbloodgroup" class="form-label">Blood Group :</label>
            <select class="form-select form-select-sm rounded cursor-pointer" role="button"
              v-model="student.bloodGroup">
              <option selected></option>
              <option v-for="(blood, i) in BloodGroups" :key="i" :value="blood">{{ blood }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Aadhaar Number :</label>
            <input type="number" class="form-control form-control-sm"
              @input="limitDigits($event, 12, v => student.aadharNumber = v)" v-model="student.aadharNumber" />
            <small v-if="aadharError" class="text-danger">{{ aadharError }}</small>
          </div>
          <div class="col-md-6">
            <label for="penNo" class="form-label">PEN Number :</label>
            <input type="text" class="form-control form-control-sm form-control form-control-sm-sm" id="penNo"
              v-model="student.penNo" />
          </div>
          <div class="col-md-6">

          </div>
          <div class="col-md-6">
            <label for="inputLastName" class="form-label">Profile Photo<sup><span
                  class="text-danger font-12">*</span></sup> :</label>
            <label for="fileImage" class="attachment-icon">
              <i class="fa fa-upload"></i>
            </label>
            <input class="form-control" id="fileImage" type="file" multiple
              accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
            <div class="d-flex align-items-start">
              <a :href="getUrl(student.image)" target="_blank" class="clearfix"> {{ student.image ?
                student.image.substring(student.image.lastIndexOf('/') + 1) : '' }} </a>
              <i role="button" v-if="student.image !== ''" @click="deleteFile(student.image, 'image')"
                class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
            </div>
          </div>
          <div class="col-md-6">
            <label for="inputZip" class="form-label">Aadhaar Photo :</label>
            <label for="fileAadhaar" class="attachment-icon">
              <i class="fa fa-upload"></i>
            </label>
            <input class="form-control" id="fileAadhaar" type="file" multiple
              accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="FileUploadImg" />
            <div class="d-flex align-items-start">
              <a :href="getUrl(student.aadharImage)" target="_blank" class="clearfix">{{ student.aadharImage ?
                student.aadharImage.substring(student.aadharImage.lastIndexOf('/') + 1) : '' }} </a>
              <i role="button" v-if="student.aadharImage !== ''" @click="deleteFile(student.aadharImage, 'aadharImage')"
                class="fa-solid fa-x text-danger f-5  ms-2 mt-2"></i>
            </div>
          </div>
          <div class="col-md-6">
            <label for="inputZip" class="form-label">Transfer Certificate :</label>
            <label for="fileTransfer" class="attachment-icon">
              <i class="fa fa-upload"></i>
            </label>
            <input class="form-control" id="fileTransfer" type="file" multiple
              accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="handleUploadImg" />
            <div class="d-flex align-items-start">
              <a :href="getUrl(student.tc)" target="_blank" class="clearfix">{{ student.tc ?
                student.tc.substring(student.tc.lastIndexOf('/') + 1) : '' }} </a>
              <i role="button" v-if="student.tc !== ''" @click="deleteFile(student.tc, 'tc')"
                class="fa-solid fa-x text-danger f-5  ms-2 mt-2"></i>
            </div>
            <div class="capture-a">
              <CapturePhoto :autoStart="true" :dwnloadfileName="'Student'"></CapturePhoto>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="p-3">
        <div class="d-flex align-items-center">
          <h5 class="mb-0 text-primary"><i class="text-primary fas fa-user"></i> Parent Details</h5>
          <button class="btn btn-success btn-sm p-0 mb-n3 mt-n2 text-end ms-auto" data-bs-toggle="modal"
            data-bs-target="#studentDetailsModal"><i class="fas fa-plus p-2"></i></button>
        </div>
        <hr />
        <div class="row g-3">
          <div class="col-md-6">
            <label for="inputFatherName" class="form-label">Father Name<sup><span
                  class="text-danger font-12">*</span></sup> :</label>
            <input type="text" class="form-control form-control-sm" id="inputFatherName"
              v-model="student.parentDetails.fatherName" />
          </div>
          <div class="col-md-6">
            <label for="inputMotherName" class="form-label">Mother Name<sup><span
                  class="text-danger font-12">*</span></sup> :</label>
            <input type="text" class="form-control form-control-sm" id="inputMotherName"
              v-model="student.parentDetails.motherName" />
          </div>
          <div class="col-md-6">
            <label for="inputEmail" class="form-label">Email<sup><span class="text-danger font-12">*</span></sup>
              :</label>
            <input type="email" class="form-control form-control-sm" id="inputEmail"
              v-model="student.parentDetails.email" />
            <span v-if="errors.Email" class="text-danger font-12">{{ errors.email }}</span>
          </div>
          <div class="col-md-6">
            <label for="inputPassword" class="form-label">Password<sup v-if="!parentId"><span
                  class="text-danger font-12">*</span></sup> :</label>
            <div class="input-group input-group-sm">
              <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="inputPassword"
                v-model="student.parentDetails.password" />
              <span class="input-group-text cursor-pointer bg-white" role="button" @click="togglePassword">
                <i :class="['fa', showPassword ? 'fa-eye' : 'fa-eye-slash']"></i>
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Phone Number<sup><span class="text-danger font-12">*</span></sup> :</label>
            <input class="form-control form-control-sm" type="number"
              @input="limitDigits($event, 10, v => student.parentDetails.phone = v)"
              v-model="student.parentDetails.phone" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Alternate Number :</label>
            <input class="form-control form-control-sm" type="number"
              @input="limitDigits($event, 10, v => student.parentDetails.altNo = v)"
              v-model="student.parentDetails.altNo" />
          </div>
          <div class="col-md-6">
            <label for="inputbloodgroup" class="form-label">Blood Group :</label>
            <select class="form-select form-select-sm rounded cursor-pointer" role="button"
              v-model="student.parentDetails.bloodGroup">
              <option selected></option>
              <option v-for="(blood, i) in BloodGroups" :key="i" :value="blood">
                {{ blood.slice(0, -1) }}<sup>{{ blood.slice(-1) }}</sup></option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Category :</label>
            <select class="form-select form-select-sm rounded cursor-pointer" role="button"
              v-model="student.parentDetails.categoryID">
              <option selected value=""></option>
              <option v-for="(item, index) in Categories" :key="index" :value="item._id">
                {{ item.Name }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Religion :</label>
            <select class="form-select form-select-sm rounded cursor-pointer" role="button"
              v-model="student.parentDetails.relId">
              <option selected value=""></option>
              <option v-for="(item, index) in Religions" :key="index" :value="item.Name">
                {{ item.Name }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="inputnumber" class="form-label">Aadhaar Number :</label>
            <input type="number" class="form-control form-control-sm"
              @input="limitDigits($event, 12, v => student.parentDetails.aadharNumber = v)"
              v-model="student.parentDetails.aadharNumber" />
            <small v-if="aadharError1" class="text-danger">{{ aadharError1 }}</small>
          </div>
          <div class="col-md-6">
            <label class="form-label"> Father Profession : </label>
            <input type="text" class="form-control form-control-sm" list="fatherProf"
              v-model="student.parentDetails.fatherProfession" />
            <datalist id="fatherProf">
              <option v-for="(item, index) in FatherList" :key="index" :value="item"></option>
            </datalist>
          </div>
          <div class="col-md-6">
            <label class="form-label"> Mother Profession : </label>
            <input type="text" class="form-control form-control-sm" list="motherProf"
              v-model="student.parentDetails.motherProfession" />
            <datalist id="motherProf">
              <option v-for="(item, index) in MotherList" :key="index" :value="item"></option>
            </datalist>
          </div>
          <div class="col-md-6">
            <label for="inputaddress" class="form-label">Address :</label>
            <textarea type="text" id="inputaddress" class="form-control form-control-sm"
              v-model="student.parentDetails.address"></textarea>
          </div>
          <div class="col-md-6">
            <label for="inputZip" class="form-label">Aadhaar Photo :</label>
            <label for="fileParAadhar" class="attachment-icon">
              <i class="fa fa-upload"></i>
            </label>
            <input class="form-control" id="fileParAadhar" type="file" multiple
              accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="FileUpldImg" />
            <div class="d-flex align-items-start">
              <a :href="getUrl(student.parentDetails.aadharPhoto)" target="_blank" class="clearfix">{{
                student.parentDetails?.aadharPhoto ?
                  student.parentDetails.aadharPhoto.substring(student.parentDetails.aadharPhoto.lastIndexOf('/') + 1) : ''
              }}</a>
              <i role="button" v-if="student.parentDetails.aadharPhoto !== ''"
                @click="deleteFile(student.parentDetails.aadharPhoto, 'parentAadhar')"
                class="fa-solid fa-x text-danger f-5 mt-2  ms-2"></i>
            </div>
          </div>
          <div class="col-md-12 text-end">
            <button class="btn btn-sm btn-darknavy me-1" @click="save">
              <i class="fa fa-save text-white"></i> Save
            </button>
            <button type="button" class="btn btn-sm btn-soft-dark waves-effect waves-light" @click="reset()"><i
                class="fas fa-times-circle  me-1"></i> Cancel</button>
          </div>
          <ul v-if="errors.length" class="text-danger ps-3">
            <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="studentDetailsModal" tabindex="-1" aria-labelledby="studentDetailsModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">StudentParent Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
        </div>
        <div class="modal-body" ref="modalTable">
          <div class="row g-3">
            <div class="col-md-3 position-relatve">
              <label class="form-label">
                Class<sup><span class="text-danger font-12">*</span></sup> :
              </label>
              <div class="dropdown w-100" data-bs-display="static">
                <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{clsList.find(c => c._id === Obj.clsID)?.name || ""}}
                </button>
                <ul class="dropdown-menu dropdown-menu-a scrollable-menu dropdown-menu-fixed">
                  <li v-for="(item, index) in uniqueClsList" :key="index">
                    <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                      {{ item.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID"
                @change="listData()">
                <option selected=""></option>
                <option v-for="(item, index) in secList" :key="index" :value="item._id">
                  {{ item.Name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Student :</label>
              <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.studentID">
                <option selected=""></option>
                <option v-for="(item, index) in
                  List1" :key="index" :value="item._id"> {{ item.firstName }} </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Parent Name :</label>
              <input type="text" class="form-control form-control-sm rounded" :value="getParentName(Obj.studentID)"
                V-model="Obj.parentId ">
            </div>
            <div class="col-md-12 text-end">
              <button class="btn btn-success btn-sm" data-bs-dismiss="modal" @click="applyParentDetails">
                <i class="fa fa-search text-white me-1"></i>Go
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm, isEmail } from "@/utils/validation.js";
import CapturePhoto from "@/components/Common/CapturePhoto.vue";
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadImg } = useFileUpload();
import { api } from '@/utils/helpers.js';
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
import { schoolStore } from '@/utils/schoolStore';
const { clsList, uniqueClsList, secList } = schoolStore();
const EditMode = ref(false);
const msgObj = ref({ msg: "", role: "", show: false, })
const parentId = ref(false);
const aadharError = ref('')
const aadharError1 = ref('')
const FatherList = ref(['Engineer', 'Job Holder', 'Businessman', 'Domestic Worker'])
const MotherList = ref(['Homemaker', 'Engineer', 'Job Holder', 'Domestic Worker'])
const student = ref({
  firstName: "",
  lastName: "",
  clsID: "",
  sectionID: "",
  rollNo: "",
  dob: new Date().toISOString().slice(0, 10),
  gender: "",
  bloodGroup: "",
  aadharNumber: "",
  aadharImage: "",
  admissionNumber: "",
  image: "",
  tc: "",
  penNo: "",
  parentDetails: {
    fatherName: "",
    motherName: "",
    email: "",
    password: "",
    phone: "",
    altNo: "",
    bloodGroup: "",
    categoryID: "",
    relId: "",
    address: "",
    aadharNumber: "",
    aadharPhoto: "",
    fatherProfession: "",
    motherProfession: "",
  },
})
const showPassword = ref(false)
const BloodGroups = ref(["A+", "A-", "O+", "O-", "AB+", "AB-", "B+", "B-"])
const Categories = ref([])
const Religions = ref([])
const List1 = ref([])
const errors = ref([])
const showMessage = ref(false)
const Obj = ref({ clsID: "", sectionID: "", studentID: "", parentId: "", })
const prevParent = ref({})
const togglePassword = async () => {
  showPassword.value = !showPassword.value
}
const applyParentDetails = () => {
  if (!Obj.value.clsID || !Obj.value.sectionID || !Obj.value.studentID) { return; }
  student.value.parentDetails = { ...prevParent.value };
  parentId.value = prevParent.value?.parentId || prevParent.value?._id || '';
  Obj.value = { clsID: "", sectionID: "", studentID: "", parentId: "" };
  List1.value = [];
};

const getParentName = (studentID) => {
  const student = List1.value.find(item => item._id === studentID);
  prevParent.value = student?.parent;
  return student?.parent?.fatherName || '';
}
const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const listData = async () => {
  await api.get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}/${Obj.value.studentID}`)
    .then((res) => { List1.value = res.data });
}
const loadCategories = async () => {
  try {
    const res = await api.get(`/Category/all`);
    Categories.value = res.data;
  }
  catch (err) { console.error("Failed to load categories", err); }
}
const loadReligions = async () => {
  try {
    const res = await api.get(`/religion/all`);
    Religions.value = res.data;
  }
  catch (err) { console.error("Failed to load categories", err); }
}
const loadDetails = async () => {
  await api
    .get(`/students/` + route.query.id)
    .then((response) => {
      student.value = response.data.student;
      student.value.lastName = student.value.lastName ?? "";
      student.value.dob = response.data.student?.dob ? new Date(response.data.student.dob).toISOString().slice(0, 10) : "";
      student.value.parentDetails = response.data.parent;
      student.value.parentDetails.parentId = response.data.parent._id;
      student.value.parentDetails.password = '';
      EditMode.value = true;
    });
}
const save = async () => {
  const fields = {
    FirstName: { value: student.value.firstName, validators: [isRequired], },
    ClassName: { value: student.value.clsID, validators: [isRequired], },
    Section: { value: student.value.sectionID, validators: [isRequired], },
    Gender: { value: student.value.gender, validators: [isRequired], },
    ProfilePhoto: { value: student.value.image, validators: [isRequired], },
    FatherName: { value: student.value.parentDetails.fatherName, validators: [isRequired], },
    MotherName: { value: student.value.parentDetails.motherName, validators: [isRequired], },
    Email: { value: student.value.parentDetails.email, validators: [isRequired, isEmail], },
    PhoneNo: { value: student.value.parentDetails.phone, validators: [(v) => { if (!v) return "Phone Number is required"; if (v.length < 10) return "Phone Number must be 10 digits"; return null; },], },
  };
  if (!EditMode.value && !parentId.value) {
    fields.Password = { value: student.value.parentDetails.password, validators: [isRequired] };
  }
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    const formData = new FormData();
    formData.append("aadharImage", student.value.aadharImage);
    formData.append("image", student.value.image);
    formData.append("tc", student.value.tc);
    formData.append("firstName", student.value.firstName);
    formData.append("lastName", student.value.lastName ?? "");
    formData.append("penNo", student.value.penNo);
    formData.append("clsID", student.value.clsID);
    formData.append("sectionID", student.value.sectionID);
    formData.append("rollNo", student.value.rollNo);
    formData.append("admissionNumber", student.value.admissionNumber);
    formData.append("dob", student.value.dob);
    formData.append("gender", student.value.gender);
    formData.append("bloodGroup", student.value.bloodGroup);
    formData.append("aadharNumber", student.value.aadharNumber);
    const parentDetails = {
      fatherName: student.value.parentDetails.fatherName,
      motherName: student.value.parentDetails.motherName,
      email: student.value.parentDetails.email,
      password: student.value.parentDetails.password,
      phone: student.value.parentDetails.phone,
      altNo: student.value.parentDetails.altNo,
      bloodGroup: student.value.parentDetails.bloodGroup,
      categoryID: student.value.parentDetails.categoryID,
      relId: student.value.parentDetails.relId,
      address: student.value.parentDetails.address,
      aadharNumber: student.value.parentDetails.aadharNumber,
      fatherProfession: student.value.parentDetails.fatherProfession,
      motherProfession: student.value.parentDetails.motherProfession,
      aadharPhoto: student.value.parentDetails.aadharPhoto,
    };
    aadharError.value = "";
    if (student.value.aadharNumber) {
      const aadhaar = String(student.value.aadharNumber).trim();
      if (!/^\d{12}$/.test(aadhaar)) {
        aadharError.value = "Aadhaar number must be 12 digits.";
        return;
      }
    }
    aadharError1.value = "";
    if (student.value.parentDetails?.aadharNumber) {
      const aadhaar = String(student.value.parentDetails.aadharNumber).trim();
      if (!/^\d{12}$/.test(aadhaar)) {
        aadharError1.value = "Aadhaar number must be 12 digits.";
        return;
      }
    }
    if (student.value.parentDetails.parentId || parentId.value) {
      parentDetails.parentId = student.value.parentDetails.parentId || parentId.value;
    }
    formData.append("parentDetails", JSON.stringify(parentDetails));
    if (route.query.id) {
      try {
        const response = await api.put(
          `/students/${route.query.id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        reset();
        showMessage.value = true;
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const response = await api.post(`/students/add`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        reset();
        showMessage.value = true;
        console.log(response);
      } catch (error) { console.log(error); }
    }
  }
}

const reset = async () => {
  student.value = {
    firstName: "",
    lastName: "",
    clsID: "",
    sectionID: "",
    rollNo: "",
    dob: new Date().toISOString().slice(0, 10),
    gender: "",
    bloodGroup: "",
    aadharNumber: "",
    aadharImage: "",
    admissionNumber: "",
    image: "",
    tc: "",
    penNo: "",
    parentDetails: {
      fatherName: "",
      motherName: "",
      email: "",
      password: "",
      phone: "",
      altNo: "",
      bloodGroup: "",
      categoryID: "",
      relId: "",
      address: "",
      aadharNumber: "",
      aadharPhoto: "",
      fatherProfession: "",
      motherProfession: "",
      parentId: ""
    }
  };
  errors.value = {};
  EditMode.value = false;
}
const deleteFile = async (filePath, field) => {
  if (!filePath) return;
  const fileName = filePath.split('/').pop();
  try {
    await api.delete(`/documents/students?filename=${fileName}`);
    switch (field) {
      case 'image':
        student.value.image = '';
        break;
      case 'aadharImage':
        student.value.aadharImage = '';
        break;
      case 'tc':
        student.value.tc = '';
        break;
      case 'parentAadhar':
        student.value.parentDetails.aadharPhoto = '';
        break;
    }
  } catch (err) {
    console.error('Failed to delete file', err);
  }
};
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = "";
    return;
  }
  if (uploadedFile) { student.value.image = uploadedFile; }
  event.target.value = null;
};
const FileUploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = "";
    return;
  }
  if (uploadedFile) { student.value.aadharImage = uploadedFile; }
  event.target.value = null;
};
const handleUploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = "";
    return;
  }
  if (uploadedFile) { student.value.tc = uploadedFile; }
  event.target.value = null;
};
const FileUpldImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = "";
    return;
  }
  if (uploadedFile) { student.value.parentDetails.aadharPhoto = uploadedFile; }
  event.target.value = null;
};
const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/default.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
onMounted(() => {
  loadDetails();
  loadCategories();
  loadReligions();
})

</script>
<style>
.modal .dropdown-menu {
  position: fixed !important;
  z-index: 99999 !important;
  inset: auto !important;
  transform: translateY(0) !important;
  margin-top: 2px !important;
}

.modal .dropdown .dropdown-menu {
  min-width: 21% !important;
}

.modal .dropdown-menu-fixed {
  max-height: 9rem;
  overflow-y: auto;
}

.position-relative {
  position: relative !important;
}

.input-group {
  height: 1.8rem;
}

.input-group>span {
  width: 18% !important;
}

.input-group-text.fw-bold.col-12 {
  width: 40%;
}

#fileImage,
#fileAadhaar,
#fileTransfer,
#fileParAadhar {
  display: none;
}

#studentDetailsModal {
  background-color: rgb(12 12 12 / 50%);
}

.f-5 {
  font-size: .5rem !important;
}

@media (max-width: 375px) {
  .ml-15 {
    margin-left: 15px;
  }
}
</style>
